import { CommonModule } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest } from 'rxjs/internal/observable/combineLatest';
import { debounceTime, filter, map, shareReplay, tap } from 'rxjs/operators';
import { AppCommonModule } from 'src/app/common.module';
import { DashboardViewComponent } from 'src/app/components/views/dashboard/view-dashboard.component';
import { NavigationService } from 'src/app/services/navigation.service';
import { UserSessionService } from 'src/app/services/user-session.service';
import { WorkerTicketsService } from 'src/app/services/worker-tickets.service';

@Component({
  selector: 'app-ticket-page',
  templateUrl: './ticket.page.html',
  styleUrls: ['./ticket.page.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AppCommonModule,
    CommonModule,
    DashboardViewComponent,
  ],
})
export class TicketPageComponent {
  private route = inject(ActivatedRoute);
  private navigationService = inject(NavigationService);
  private usersService = inject(UserSessionService);
  private workerTicketsService = inject(WorkerTicketsService);

  ticket$ = combineLatest([this.usersService.getCurrentUser(), this.route.queryParams]).pipe(
    filter(([user, params]) => user != null && params != null),
    map(([_, params]) => this.workerTicketsService.openRoomTicket(params['guid'], params['ticket'], false, ['workspace-modal'])),
    debounceTime(200),
    tap(async () => this.navigationService.navigateToHome()),
    shareReplay({ bufferSize: 1, refCount: true }),
  );
}
